import { Maybe } from "graphql/_Types";
import { FILE_TYPES_BY_ID } from "types/FileTypes";

export const getTagsList = (
  tags: Maybe<string>[] | null | undefined,
  fileTypes: Maybe<number>[] | null | undefined,
): string[] => {
  // create a unique list of tags and file types
  const tagsSet = new Set<string>();
  if (tags) {
    tags.forEach((tag) => {
      if (tag !== null && tag.trim() !== "") {
        tagsSet.add(tag.trim());
      }
    });
  }
  if (fileTypes) {
    fileTypes.forEach((type) => {
      if (type !== null) {
        const typeName = FILE_TYPES_BY_ID[type]?.name;
        if (typeName !== undefined) {
          tagsSet.add(typeName);
        }
      }
    });
  }
  return Array.from(tagsSet).sort();
};
